import React, { memo, useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Navbar, NavDropdown, Offcanvas } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/img/logoApp.png";
import CustomModal from "./CustomModal";
import ConnectForm from "../user/ConnectForm";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faBars,
  faTimes,
  faChevronDown,
  faChevronUp,
  faInfoCircle,
  faHandshake,
  faNewspaper,
  faEnvelope,
  faLightbulb,
  faUserCircle,
  faSchool,
  faChevronRight,
  faUserTie,
  faSignInAlt,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import { HashLink } from "react-router-hash-link";
import profile from "../../assets/img/icone_profil.png";
import { specialPaths } from "../../utils/variable";
import { useModal } from "../../hooks/useModal";
import useSocialMedia from "../../hooks/useSocialMedia";
import { useSelector } from "react-redux";
import {
  selectIsAuthenticated,
  selectUser,
} from "../../features/auth/authSlice";
import { faHome } from "@fortawesome/free-solid-svg-icons/faHome";
import { useScroll } from "framer-motion";

const NavBar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isOpen, openModal, closeModal } = useModal();
  const { handleLogout } = useSocialMedia();
  const user = useSelector(selectUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const [dropdownOpen, setDropdownOpen] = useState({
    campus: false,
    programmes: false,
    otherProgrammes: false,
    services: false,
  });

  const toggleDropdown = (key) => {
    setDropdownOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleToggleClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleClose = () => setIsMenuOpen(false);
  const [selectedCampus, setSelectedCampus] = useState("Nos campus");

  const handleCampusSelect = (campus) => {
    setSelectedCampus(campus);
  };

  const isSpecialPage = () =>
    specialPaths.some((path) => location.pathname.toLowerCase().includes(path));

  const { scrollY } = useScroll(); // Hook pour gérer le scroll
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Écoute des changements de `scrollY`
    const unsubscribe = scrollY.onChange((latest) => {
      setIsScrolled(latest > 50);
    });

    return () => unsubscribe();
  }, [scrollY]);

  return (
    <>
      <Navbar
        fixed={`${isSpecialPage() ? "" : "top"}`}
        variant="dark"
        expand="lg"
        className={`${
          isSpecialPage()
            ? "bg-b"
            : isScrolled
            ? "carousel-navbar bg-b"
            : "carousel-navbar bg-transparent"
        } py-0`}
        style={{
          transition: "background-color 0.3s ease",
        }}
      >
        <Container fluid>
          <Navbar.Brand
            as={NavLink}
            to="/"
            className="d-flex  align-items-center"
          >
            <img
              loading="lazy"
              src={logo}
              alt="Logo"
              width="170"
              height="60"
              className="d-inline-block mx-2 mx-md-0  rounded bg-white align-top me-2"
            />
          </Navbar.Brand>

          <Navbar.Toggle
            onClick={handleToggleClick}
            className="text-white a bg-b me-2"
          >
            <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
          </Navbar.Toggle>

          <Offcanvas show={isMenuOpen} onHide={handleClose} placement="start">
            <Offcanvas.Header closeButton className="bg-b text-white">
              <Offcanvas.Title className="fs-4">F.I.C.S</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body className="d-flex flex-column p-4">
              {/* Liens de navigation */}
              <NavLink
                to="/"
                className="d-flex align-items-center text-lowercase my-2 p-2 bg-light rounded text-dark"
                onClick={handleClose}
              >
                <FontAwesomeIcon icon={faHome} className="me-3" />
                Acceuil
              </NavLink>

              <NavLink
                to="/about"
                className="d-flex align-items-center my-2 p-2 bg-light rounded text-dark"
                onClick={handleClose}
              >
                <FontAwesomeIcon icon={faInfoCircle} className="me-3" />À propos
              </NavLink>

              <HashLink
                smooth
                to="/#partenaire"
                className="d-flex align-items-center my-2 p-2 bg-light rounded text-dark"
                onClick={handleClose}
              >
                <FontAwesomeIcon icon={faHandshake} className="me-3" />
                Partenaires
              </HashLink>

              {/* Menu déroulant : Nos Formations */}
              <div className="dropdown">
                <button
                  className="btn btn-light w-100 d-flex align-items-center my-2 p-2"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faGraduationCap} className="me-3" />
                  Nos formations
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink
                      to="/prepa-gd"
                      className="dropdown-item"
                      onClick={handleClose}
                    >
                      Prépa Grand École Canadienne
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/prepa-hybride"
                      className="dropdown-item"
                      onClick={handleClose}
                    >
                      Programme Hybride
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/autre-formation"
                      className="dropdown-item"
                      onClick={handleClose}
                    >
                      Autre Formation
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/autre-service"
                      className="dropdown-item"
                      onClick={handleClose}
                    >
                      Autre Service
                    </NavLink>
                  </li>
                </ul>
              </div>

              {/* Menu déroulant : Campus */}
              <div className="dropdown">
                <button
                  className="btn btn-light w-100 d-flex align-items-center my-2 p-2"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faSchool} className="me-3" />
                  Campus
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink
                      to="/campus/SENEGAL"
                      className="dropdown-item"
                      onClick={handleClose}
                    >
                      SENEGAL
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/campus/CAMEROUN"
                      className="dropdown-item"
                      onClick={handleClose}
                    >
                      CAMEROUN
                    </NavLink>
                  </li>
                </ul>
              </div>

              <HashLink
                smooth
                to="/#actualite"
                className="d-flex align-items-center my-2 p-2 bg-light rounded text-dark"
                onClick={handleClose}
              >
                <FontAwesomeIcon icon={faNewspaper} className="me-3" />
                Actualites
              </HashLink>

              <NavLink
                to="/contacts"
                className="d-flex align-items-center my-2 p-2 bg-light rounded text-dark"
                onClick={handleClose}
              >
                <FontAwesomeIcon icon={faEnvelope} className="me-3" />
                Contact
              </NavLink>

              <a
                href="https://performance-immigration.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center my-2 p-2 bg-danger rounded text-white text-center"
              >
                <FontAwesomeIcon icon={faLightbulb} className="me-3" />
                PERSPECTIVE D’AVENIR
              </a>

              {/* Connexion */}
              {isAuthenticated ? (
                <NavLink
                  to="/espace-etudiant/candidate"
                  className="d-flex align-items-center my-2 p-2 bg-light rounded text-dark"
                  onClick={handleClose}
                >
                  <FontAwesomeIcon icon={faUser} className="me-3" />
                  COMPTE
                </NavLink>
              ) : (
                <button
                  className="d-flex align-items-center my-2 p-2 bg-light rounded text-dark"
                  onClick={openModal}
                >
                  <FontAwesomeIcon icon={faSignInAlt} className="me-3" />
                  Se connecter
                </button>
              )}
            </Offcanvas.Body>
          </Offcanvas>

          {/* Liens alignés à droite */}
          <Navbar.Collapse className="d-lg-block d-none">
            <Nav className="ms-auto d-lg-flex align-items-lg-center gap-1 list-unstyled text-decoration-none flex-column flex-lg-row">
              <NavLink
                className={({ isActive }) =>
                  isActive ? "actives bg-white" : "text-white fs-05"
                }
                to="/"
              >
                <span className="pe-2 text-truncate">Acceuil</span>
                <span className="border-end"></span>
              </NavLink>

              <NavDropdown
                id="fcis-nav-dropdown"
                drop="down-centered"
                show={dropdownOpen.fcis}
                title={
                  <>
                    <span className="fs-05 text-truncate">
                      FCIS{" "}
                      <FontAwesomeIcon
                        icon={dropdownOpen.fcis ? faChevronUp : faChevronDown}
                        className="ms-2 text-white"
                      />
                    </span>
                  </>
                }
                className="fs-05"
                menuClassName="custom-dropdown-menu"
                onMouseEnter={() => toggleDropdown("fcis")}
                onMouseLeave={() => toggleDropdown("fcis")}
              >
                <NavDropdown.Item
                  as={NavLink}
                  to="/about"
                  className={({ isActive }) => (isActive ? "actives" : "")}
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginRight: "0.5rem" }}
                    className="icon"
                  />
                  À propos
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={NavLink}
                  to="/pdg"
                  className={({ isActive }) => (isActive ? "actives" : "")}
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginRight: "0.5rem" }}
                    className="icon"
                  />
                  Mot de la PDG
                </NavDropdown.Item>
              </NavDropdown>

              <HashLink
                smooth
                className="text-white fs-05 text-truncate"
                to="/#partenaire"
              >
                Partenaires <span className="border-end pe-3"></span>
              </HashLink>

              <NavDropdown
                id="basic-nav-dropdown"
                drop="down-centered"
                show={dropdownOpen.programmes}
                title={
                  <>
                    <span className="fs-05 text-truncate">
                      Nos formations{" "}
                      <FontAwesomeIcon
                        icon={
                          dropdownOpen.programmes ? faChevronUp : faChevronDown
                        }
                        className="ms-2 text-white"
                      />
                    </span>
                    <span className="border-end pe-3"></span>
                  </>
                }
                onMouseEnter={() => toggleDropdown("programmes")}
                onMouseLeave={() => toggleDropdown("programmes")}
                className="fs-05"
              >
                <NavDropdown.Item
                  as={NavLink}
                  to="/curriculum"
                  className={({ isActive }) => (isActive ? "actives" : "a")}
                  style={{
                    padding: "0.75rem 1.5rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginRight: "0.5rem" }}
                    className="icon"
                  />
                  Curriculum candien
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={NavLink}
                  to="/prepa-gd"
                  className={({ isActive }) => (isActive ? "actives" : "a")}
                  style={{
                    padding: "0.75rem 1.5rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginRight: "0.5rem" }}
                    className="icon"
                  />
                  Prépa Grand École Canadienne
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={NavLink}
                  to="prepa-hybride"
                  className={({ isActive }) => (isActive ? "actives" : "a")}
                  style={{
                    padding: "0.75rem 1.5rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginRight: "0.5rem" }}
                    className="icon"
                  />
                  Programme Hybride
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={NavLink}
                  to="autre-service"
                  className={({ isActive }) => (isActive ? "actives" : "a")}
                  style={{
                    padding: "0.75rem 1.5rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginRight: "0.5rem" }}
                    className="icon"
                  />
                  Autre Service
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                id="basic-nav-dropdown"
                drop="down-centered"
                show={dropdownOpen.campus}
                title={
                  <>
                    <span className="fs-05 text-truncate">
                      {selectedCampus}{" "}
                      <FontAwesomeIcon
                        icon={dropdownOpen.campus ? faChevronUp : faChevronDown}
                        className="ms-2 text-white"
                      />
                    </span>
                    <span className="border-end pe-3"></span>
                  </>
                }
                onMouseEnter={() => toggleDropdown("campus")}
                onMouseLeave={() => toggleDropdown("campus")}
                className="fs-05"
              >
                <NavDropdown.Item
                  as={NavLink}
                  to="/campus/SENEGAL"
                  className={({ isActive }) => (isActive ? "actives" : "a")}
                  onClick={() => handleCampusSelect("SENEGAL")}
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginRight: "0.5rem" }}
                    className="icon"
                  />
                  SENEGAL
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={NavLink}
                  to="/campus/CAMEROUN"
                  className={({ isActive }) => (isActive ? "actives" : "a")}
                  onClick={() => handleCampusSelect("CAMEROUN")}
                >
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ marginRight: "0.5rem" }}
                    className="icon"
                  />
                  CAMEROUN
                </NavDropdown.Item>
              </NavDropdown>

              <HashLink smooth className="text-white fs-05" to="/#actualite">
                Actualites <span className="border-end pe-3"></span>
              </HashLink>

              <NavLink
                className={({ isActive }) =>
                  isActive ? "actives" : "text-white fs-05 mx-2"
                }
                to="/contacts"
              >
                Contact
              </NavLink>

              <a
                href="https://performance-immigration.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white p-2 text-center rounded-5 bg-red my-2 fs-05"
              >
                PERSPECTIVE D’AVENIR{" "}
                <span className="border-end pe-3 d-md-block d-none"></span>
              </a>

              {isAuthenticated ? (
                <>
                  <NavLink
                    className={({ isActive }) =>
                      isActive ? "active" : "text-white fs-05"
                    }
                    to="/espace-etudiant/candidate"
                  >
                    COMPTE <span className="border-end pe-3"></span>
                  </NavLink>
                  <hr className="d-lg-none w-100 my-1 a" />
                </>
              ) : (
                <Nav.Link
                  className={`${
                    isScrolled ? "bg-white text-dark fs-05" : "bg-b text-white"
                  } text-center rounded-5 my-2 fs-05`}
                  onClick={() => openModal()}
                >
                  <FontAwesomeIcon icon={faUser} className="pe-2" />
                  Se connecter
                </Nav.Link>
              )}

              {isAuthenticated && (
                <NavDropdown
                  title={
                    <img
                      loading="lazy"
                      src={profile}
                      alt="Profile"
                      style={{
                        width: "25px",
                        height: "25px",
                        marginRight: "10px",
                      }}
                    />
                  }
                  id="basic-nav-dropdown"
                  drop="start"
                >
                  <NavDropdown.Item href="#action/3.3">
                    {user?.displayName}
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={handleLogout}
                    className="text-danger"
                  >
                    Déconnexion
                  </NavDropdown.Item>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* MODAL  */}
      <CustomModal
        isOpen={isOpen}
        onRequestClose={() => closeModal()}
        title={"Connexion"}
        id={`staticBackdrop_connexion`}
        key={"connexion"}
      >
        <ConnectForm />
      </CustomModal>
    </>
  );
};

export default memo(NavBar);
